import React from 'react';

import './HelpContent.component.scss';

/* ----- Main Component ----- */
const HelpContent = () => {
    return (
        <div className="help-content">
            <p> Guess the <strong>BRANDLE</strong> in 5 guesses.</p> 
            <p> Each day you'll see a different obscured logo from one of the top brands in the world!</p> 
            <p> After any failed guess, you will see more of the logo appear to help on your future 
                guesses. After a successful guess, the line will turn green and a 🎉 will appear.</p>                
            <p className='last'>Each guess must be a valid brand name and our menu will show the proper spelling of each company you enter.</p>                
            
            <p> <strong>A new <span>BRAND</span>LE will be available every day! Compete with your friends and share.</strong></p> 
            <p> <strong>BRANDLE is made by <a href="https://www.dysrupt.com/"> dysrupt</a>. If you are interested in making the impossible profitable, 
            learn more about dysrupt <a href="https://www.dysrupt.com/">here</a>. </strong>
            </p>            
        </div>
    );
};

export default HelpContent;
